import script from "./TradersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradersView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__